import { MetricDataType, MetricSign } from "../../../recovery/component/recovery-metrics-panel/entity/DefaultMetric";
import { DefaultMetricGroup } from "../../../recovery/component/recovery-metrics-panel/entity/DefaultMetricGroup";
import { MetricGroup } from "../../dto/MetricGroup";

export interface MetricGroupCrudSignWithIcon {
  sign: MetricSign;
  iconNameAndStylingLeft: string;
}

export interface MetricGroupCrudDataTypeWithIcon extends MetricGroupCrudSignWithIcon {
  dataType: MetricDataType;
  displayName: string;
}

export const metricSignsWithIcons: MetricGroupCrudSignWithIcon[] = [
  {
    sign: MetricSign.ANY,
    iconNameAndStylingLeft: 'plus-minus.svg',
  },
  {
    sign: MetricSign.POSITIVE,
    iconNameAndStylingLeft: 'plus.svg',
  },
  {
    sign: MetricSign.NEGATIVE,
    iconNameAndStylingLeft: 'minus.svg',
  },
];

export const metricDataTypesWithIcons: MetricGroupCrudDataTypeWithIcon[] = [
  {
    dataType: MetricDataType.STRING,
    sign: MetricSign.ANY,
    iconNameAndStylingLeft: 'abc.svg',
    displayName: 'Text',
  },
  {
    dataType: MetricDataType.PERCENT,
    sign: MetricSign.ANY,
    iconNameAndStylingLeft: 'percent.svg',
    displayName: MetricDataType.PERCENT,
  },
  {
    dataType: MetricDataType.DATE,
    sign: MetricSign.ANY,
    iconNameAndStylingLeft: 'calendar.svg',
    displayName: MetricDataType.DATE,
  },
  {
    dataType: MetricDataType.NUMBER,
    sign: MetricSign.ANY,
    iconNameAndStylingLeft: 'plus-minus.svg',
    displayName: MetricDataType.NUMBER,
  },
  {
    dataType: MetricDataType.DOCUMENT,
    sign: MetricSign.ANY,
    iconNameAndStylingLeft: 'upload-arrow-in-rectangle.svg',
    displayName: MetricDataType.DOCUMENT,
  },
];

export interface ModalTypeAndGroupInfo {
  group: DefaultMetricGroup | MetricGroup;
  modalType: MetricGroupCrudType;
  enableForAllCompanies: boolean;
}

export type MetricGroupCrudType = 'create' | 'update';

export type MetricGroupDataType = 'Numbers with balances' | 'Any metrics';
